export const SIZE_HIGH = 'size-high';
export const SIZE_MEDIUM = 'size-medium';
export const SIZE_LARGE = 'size-large';

export const SIZES = [
    SIZE_HIGH,
    SIZE_LARGE,
    SIZE_MEDIUM
];


export const TYPE_TRANSPARENT = 'type-transparent';
export const TYPE_WHITE = 'type-white';

export const TYPES = [
    TYPE_TRANSPARENT,
    TYPE_WHITE
];
